import { promise } from '../../../helpers';

const validateOnSaveTaskSubmission = () => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        return promise({ success: true });
    };
};

export default validateOnSaveTaskSubmission;
